/**
 * Admin Moderation Page
 * 
 * Page wrapper that integrates the Elm-ish admin-moderation feature.
 */

import React, { useReducer } from 'react';
import { AdminModerationModel, initialModel } from '@/features/admin-moderation/model';
import { Msg } from '@/features/admin-moderation/messages';
import { update } from '@/features/admin-moderation/update';
import { AdminModerationView } from '@/features/admin-moderation/view';

/**
 * Admin Moderation Page component.
 * Implements the Elm-ish program pattern by wrapping the feature view.
 */
export function AdminModerationPage(): JSX.Element {
  const [model, dispatch] = useReducer(update, initialModel);

  // Initial load on mount
  React.useEffect(() => {
    dispatch({ type: 'queue-load-started' });
  }, []);

  return <AdminModerationView model={model} dispatch={dispatch} />;
}